'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { Capacitor } from '@capacitor/core'
import { PROD_APP_URL_LIST } from '@/lib/constant'

export function LinkHandler() {
  const router = useRouter()

  useEffect(() => {
    // Only run on native platforms
    if (!Capacitor.isNativePlatform()) return

    const handleClick = (e: MouseEvent) => {
      // Ignore if already handled
      if (e.defaultPrevented) return

      // Find the closest anchor tag
      const target = (e.target as HTMLElement).closest('a')
      if (!target) return

      const href = target.getAttribute('href')
      if (!href) return

      // Handle absolute URLs that point to our domains
      try {
        const url = new URL(href, window.location.href)

        // Check if the link matches any of our production domains
        const isInternalDomain = PROD_APP_URL_LIST.some((prodUrl) => {
          try {
            const prodObj = new URL(prodUrl)
            return url.hostname === prodObj.hostname
          } catch {
            return false
          }
        })

        // Also check if it's the same domain as current (e.g. localhost or ip)
        const isCurrentDomain = url.hostname === window.location.hostname

        if (isInternalDomain || isCurrentDomain) {
          // It's an internal link
          e.preventDefault()

          // Extract the path and query
          const path = url.pathname + url.search + url.hash

          // Use Next.js router to navigate
          router.push(path)
        }
      } catch (err) {
        // Invalid URL, ignore
      }
    }

    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [router])

  return null
}
